<form [formGroup]="licenseForm">
  <mat-form-field appearance="outline" class="row">
    <mat-label>Department of Business and Professional Regulation License Number</mat-label>
    <input formControlName="licenseNumber" matInput>
  </mat-form-field>
  <mat-card class="row certificate-container" appearance="outlined">
    <h5 class="column">Provide one of these fields in order to submit your property</h5>
    <mat-form-field appearance="outline" class="column">
      <mat-label>Florida State Department of Revenue Sales Tax Certificate Number</mat-label>
      <input formControlName="taxNumber" matInput required (blur)="onTaxNumberBlur()">
    </mat-form-field>
    <mat-checkbox formControlName="appliedFor">State Certificate has been applied for</mat-checkbox>
    <mat-form-field appearance="outline" class="column">
      <mat-label>If the property has not been registered, please state the reason why</mat-label>
      <input formControlName="notRegisteredReason" matInput required>
    </mat-form-field>
  </mat-card>
</form>